import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type TermoCompromissoPublicidadePjJob = ReportJob;
export type TermoCompromissoPublicidadePjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Termo de Compromisso para Publicidade PJ. */
@Injectable({ providedIn: 'root' })
export class TermoCompromissoPublicidadePjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'termo-compromisso-publicidade-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.termoCompromissoPublicidadePj;
}
